import {useDispatch as useOriginalDispatch} from 'react-redux'
import {Dispatch} from 'redux'
import {RouterActions} from 'redux-first-history'

import {Actions} from '../actions'

type MapResultToPromise<T> = T extends (...args: infer U) => infer R
  ? (...args: U) => Promise<R>
  : T

export type AppDispatch = MapResultToPromise<Dispatch<Actions | RouterActions>>

// Use throughout the app instead of plain `useDispatch`
export default () => useOriginalDispatch<AppDispatch>()
